import { render } from "./NavBar.vue?vue&type=template&id=5804638f"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"

import "./NavBar.vue?vue&type=style&index=0&id=5804638f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/NavBar/NavBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5804638f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5804638f', __exports__)) {
    api.reload('5804638f', __exports__)
  }
  
  module.hot.accept("./NavBar.vue?vue&type=template&id=5804638f", () => {
    api.rerender('5804638f', render)
  })

}


export default __exports__